import { useCallback } from 'react';
import { useReferralListSlice } from 'app/pages/referral-list/slice';

interface UseCreateReferralNoteProps {
  referralId: string | null;
}

export const useCreateReferralNote = ({ referralId }: UseCreateReferralNoteProps) => {
  const { useCreateReferralNoteMutation } = useReferralListSlice();
  const [createNote, { isLoading: isCreatingNote }] = useCreateReferralNoteMutation();

  const handleCreateNote = useCallback(async (content: string) => {
    if (!referralId || !content.trim()) return;

    try {
      await createNote({
        referralId: referralId,
        data: { text: content.trim() }
      }).unwrap();
      return true;
    } catch (error) {
      console.error('Error creating note:', error);
      return false;
    }
  }, [referralId, createNote]);

  return {
    createNote: handleCreateNote,
    isCreatingNote
  };
}; 